import { API_URL } from '../../../app-config/constants';
import { UserSettings } from '../../react/features/UserSettings/types';
import { get, post } from '../request';

const RESOURCE = `${API_URL}/user-settings`;

getUserSettings.operation = 'READ';
export function getUserSettings() {
    return get<UserSettings>(RESOURCE);
}

updateUserSettings.operation = 'COMMAND';
export function updateUserSettings(settings: UserSettings) {
    return post<UserSettings>(RESOURCE, { postData: settings });
}

setCheckedReleaseNotes.operation = 'COMMAND';
export function setCheckedReleaseNotes() {
    return post<UserSettings>(`${RESOURCE}/checked-release-notes`);
}
